
import React, { useState } from 'react'
import Logo from '../assets/g.png'
 import {FaBars,FaTimes ,FaGithub,FaLinkedin} from 'react-icons/fa'
import {BsFillPersonLinesFill} from 'react-icons/bs'
import {HiOutlineMail} from 'react-icons/hi'

import { Link } from 'react-scroll';

 function Navbar() {
const [nav,setNav]=useState(false)

const handleclick=()=>{
  setNav(!nav)
}

  return (
  
  
    <div className="fixed w-full h-[80px] z-50 flex justify-between items-center px-4 bg-[#0a192f] text-gray-300">
    <div>   
     <img src={Logo} alt="Vivek" style={{width:"80px"}}></img>
    </div>

  {/*menu */}

  <ul className='hidden md:flex font-bold'>
  
  <li className='hover:underline duration-300'>
   <Link to="home"  smooth={true} duration={500} >
Home
</Link>
</li>
  <li className='hover:underline duration-300'>
  <Link to="about"  smooth={true} duration={500} >
  About
  </Link>
  </li>
  <li className='hover:underline duration-300'>
  
  <Link to="skills"  smooth={true} duration={500} >
Skills
  </Link>
  </li>
  <li className='hover:underline duration-300'>
  <Link to="projects"  smooth={true} duration={500} >
  Projects
  </Link>
  </li>
  <li className='hover:underline duration-300'>
  
  <Link to="contact"  smooth={true} duration={500} >
  Contact
  </Link>
  </li>
  </ul>
  


  {/* Hamburger */}

  <div className="md:hidden z-10" onClick={handleclick}>
  {nav?<FaTimes/>:<FaBars/>}
  </div>

  {/* mobile menu */}

 <ul className={nav?"absolute top-0 left-0 w-full h-screen  bg-[#0a192f] flex flex-col justify-center items-center":"hidden"}>
 
  
  <li className='py-6 text-4xl'> <Link onClick={handleclick} to='home' smooth={true} duration={500}>
  Home
</Link></li>
  <li className='py-6 text-4xl'><Link onClick={handleclick} to='about' smooth={true} duration={500}>
  About
</Link></li>
  <li className='py-6 text-4xl'><Link onClick={handleclick} to='skills' smooth={true} duration={500}>
  Skills
</Link></li>
  <li className='py-6 text-4xl'>
  <Link onClick={handleclick} to='projects' smooth={true} duration={500}>
  Projects
</Link></li>
  <li className='py-6 text-4xl'><Link onClick={handleclick} to='contact' smooth={true} duration={500}>
  Contact
</Link></li>
  </ul> 

{/** Social icons */}
  <div className='hidden lg:flex fixed flex-col top-[35%] left-0'>
  
  <ul>
   <li className='w-[160px] h-[60px] flex justify-between items-center bg-blue-500 ml-[-100px] hover:ml-[-10px] duration-300'>
  <a href="https://www.linkedin.com/in/vivek-kumar-54a048223/" target="_blank"  rel="noreferrer" className='flex justify-between items-center w-full text-gray-300'>
  LinkedIn <FaLinkedin size={30}/>
  </a>
  </li>


  <li className='w-[160px] h-[60px] flex justify-between items-center bg-[#333333] ml-[-100px] hover:ml-[-10px] duration-300'>
  <a href="https://github.com/vivekKumarSinghH" target="_blank"  rel="noreferrer" className='flex justify-between items-center w-full text-gray-300'>
  Github <FaGithub size={30}/>
  </a>
  </li>

 

  <li className='w-[160px] h-[60px] flex justify-between items-center bg-[#565f69] ml-[-100px] hover:ml-[-10px] duration-300'>
  <a href="https://drive.google.com/drive/folders/1DI8IhXNTdyg34d6Pj6PIF3eu7bF6JC_s?usp=sharing" target="_blank"  rel="noreferrer" className='flex justify-between items-center w-full text-gray-300'>
  Resume <BsFillPersonLinesFill size={30}/>
  </a>
  </li>


  </ul>
  </div>


</div>
  )
}

export default Navbar